export const CoatingSystemImageHeight: number = 45;
